import type { ConstraintsData, SectionStatus } from '../../types/canvas';
import { ActionBar } from './ActionBar';

interface ConstraintsCardProps {
  data: ConstraintsData;
  status: SectionStatus;
  onApprove?: () => void;
  onRefine?: () => void;
  onAnother?: () => void;
  refineDisabled?: boolean;
}

export function ConstraintsCard({ data, status, onApprove, onRefine, onAnother, refineDisabled }: ConstraintsCardProps) {
  return (
    <div className="bg-surface border border-border rounded-lg p-[18px] sm:px-[22px]">
      <h3 className="text-[15px] font-semibold text-foreground mb-3">Constraints</h3>
      <div className="flex flex-wrap gap-1.5">
        {data.constraints.map((c, i) => (
          <span
            key={i}
            className="text-xs py-[5px] px-3 rounded-full bg-background border border-border text-muted-foreground flex items-center gap-1.5"
          >
            <span className="text-destructive font-semibold text-[11px]" aria-hidden="true">&times;</span>
            {c}
          </span>
        ))}
      </div>
      <ActionBar status={status} onApprove={onApprove} onRefine={onRefine} onAnother={onAnother} refineDisabled={refineDisabled} />
    </div>
  );
}
